/**
 * 主要抽象出平台间交互的函数
 */

import { addQueryToUrl } from '@/utils/utils'
import {
  getVerifyPhoneApi,
  getVerifyUserAuthApi,
  getCryptoValidationApi
} from '@/api/ukey'
import { MessageBox } from 'element-ui'
import store from '@/store'

/**
 * @param noticeId 公告ID
 */
export function jumpToPortalAnnouncement(noticeId) {
  window.open(`${process.env.VUE_APP_PORTAL_URL}/notice/${noticeId}`, '_blank')
}

/**
 * 跳转至会员购买页
 */
export function toVipBuy() {
  // 防止当前页面有beforeunload的阻拦
  window.onbeforeunload = null
  const url = process.env.VUE_APP_PORTAL_URL + '/value-added/vip/buy'
  window.open(url, '_self')
}

/**
 * 跳转至专家平台
 */
export function toExpertPlatform({
  page,
  pageParams,
  pageQuery,
  target = '_blank'
}) {
  const url = addQueryToUrl(
    process.env.VUE_APP_EXPERT_URL + '/blank-page',
    {
      type: 4,
      targetRouterName: page,
      pageParams,
      pageQuery
    },
    false
  )

  window.open(url, target)
}

/**
 * 跳转线上评审
 * @param page
 * @param reviewId
 * @param orderId
 * @param purchaseType
 */
export function toReviewOnlineHall({
  page = 'ReviewOnlineSession',
  reviewId,
  orderId,
  purchaseType
}) {
  toExpertPlatform({
    page: page,
    pageParams: JSON.stringify({
      reviewId,
      orderId,
      identity: 'purchaser'
    }),
    pageQuery: JSON.stringify({ purchaseType })
  })
}

/**
 * 校验招标详情信息是否一致
 */
export async function verifyBiddingInfoHandel(data, pageName, tableType) {
  // 是否开启国密
  const isGuoMi = store.state.system.isGuoMi
  if (isGuoMi) {
    let orderName = data?.orderName || ''
    let orderCode = data?.orderCode || ''
    let biddingAttachmentIds = JSON.stringify(data?.biddingAttachmentIds)
    let title = data?.title || ''
    let content = data?.content || ''
    let orderId = data?.orderId
    let noticeId = data?.noticeId
    let tableTypeText = '招标表'
    if (tableType == 4) {
      // 查询统计
      orderName = data?.projectInfo?.orderName || ''
      orderCode = data?.projectInfo?.orderCode || ''
      biddingAttachmentIds = JSON.stringify(
        data?.fileInfo?.biddingAttachmentIds
      )
      title = data?.noticeList[0]?.title || ''
      content = data?.noticeList[0]?.content || ''
      orderId = data?.orderId
      noticeId = data?.noticeList[0]?.noticeId
      tableTypeText = '招标表'
    } else {
      orderName = data?.orderName || ''
      orderCode = data?.orderCode || ''
      biddingAttachmentIds = JSON.stringify(data?.biddingAttachmentIds)
      title = data?.title || ''
      content = data?.content || ''
      orderId = data?.orderId
      noticeId = data?.noticeId
      tableTypeText = '招标表'
    }
    const params1 = {
      id: orderId,
      tableType: tableTypeText
    }
    let data1 = [
      { value: orderCode, columnType: '项目编号' },
      { value: orderName, columnType: '项目名称' }
    ]
    if (biddingAttachmentIds) {
      data1 = [
        { value: orderCode, columnType: '项目编号' },
        { value: orderName, columnType: '项目名称' },
        { value: biddingAttachmentIds, columnType: '项目文件' }
      ]
    }
    const res1 = await getCryptoValidationApi(data1, params1)
    const dataValue1 = res1?.data || []

    let dataValue2 = []
    if (noticeId) {
      const params2 = {
        id: noticeId,
        tableType: '公告表'
      }
      const data2 = [
        { value: title, columnType: '公告标题' },
        { value: content, columnType: '公告内容' }
      ]
      const res2 = await getCryptoValidationApi(data2, params2)
      dataValue2 = res2?.data || []
    }

    const dataValue = [...dataValue1, ...dataValue2]
    const massageContentArr = []
    dataValue.forEach(item => {
      if (item.success === false) {
        if (item.columnType === '项目文件') {
          massageContentArr.push('项目文件')
        } else if (item.columnType === '公告内容') {
          massageContentArr.push('公告内容')
        } else {
          massageContentArr.push(item.value)
        }
      }
    })

    if (massageContentArr.length) {
      const massageContent = massageContentArr.join('、')
      const massageTitle = `<div style="font-size: 16px;font-weight: bold;"><i class="el-icon-warning" style="margin-right: 5px; color: #faad14; font-size: 18px;"></i>数据篡改提示</div>`
      const massageContentBox = `<div style="max-height: 300px; overflow-y:auto; margin-left: 20px; color: #ff4d4f;">当前页面 ${massageContent} 可能数据被篡改，请注意风险</div>`
      MessageBox.alert(massageTitle + massageContentBox, '', {
        dangerouslyUseHTMLString: true,
        showCancelButton: true,
        cancelButtonText: '取消',
        confirmButtonText: '好的'
      })
        .then(() => {})
        .catch(action => {})
    }
  }
}

/**
 * 校验招标列表信息是否一致
 */
export async function verifyBiddingListHandel(list, pageName, tableType) {
  // 是否开启国密-列表校验暂时不做
  const isGuoMi = store.state.system.isGuoMi
  if (isGuoMi) {
    let massageContent = ''
    const massageContentArr = []
    for (const i in list) {
      // 过滤未发布状态
      const params = {
        id: list[i].orderId,
        tableType: '招标表'
      }
      const data = [
        { value: list[i].orderCode, columnType: '项目编号' },
        { value: list[i].orderName, columnType: '项目名称' }
      ]

      const res = await getCryptoValidationApi(data, params)
      const verifyInfoData = res.data || []
      verifyInfoData.forEach(item => {
        if (item.success === false) {
          massageContentArr.push(item.value)
        }
      })
    }
    if (massageContentArr.length) {
      massageContent = massageContentArr.join('、')
      const massageTitle = `<div style="font-size: 16px;font-weight: bold;"><i class="el-icon-warning" style="margin-right: 5px; color: #faad14; font-size: 18px;"></i>数据篡改提示</div>`
      const massageContentBox = `<div style="max-height: 300px; overflow-y:auto; margin-left: 20px; color: #ff4d4f;">当前页面 ${massageContent} 可能数据被篡改，请注意风险</div>`
      MessageBox.alert(massageTitle + massageContentBox, '', {
        dangerouslyUseHTMLString: true,
        showCancelButton: true,
        cancelButtonText: '取消',
        confirmButtonText: '好的'
      })
        .then(() => {})
        .catch(action => {})
    }
  }
}

/**
 * 检测企业用户手机号、权限与数据库哈希值是否一致，若不一致，弹出提示并返回登录页
 */
export async function verifyPhoneHandel() {
  // 是否开启国密
  const isGuoMi = store.state.system.isGuoMi
  // 用户手机号
  const mobile = store.state.user.mobile
  if (isGuoMi) {
    await store.dispatch('user/getEmployeeInfo')
    const params = {
      mobile: mobile
    }
    const res = await getVerifyPhoneApi(params)
    if (res?.data && res?.data?.success === false) {
      window.onbeforeunload = null
      store
        .dispatch('user/logout')
        .then(res => {})
        .catch(err => {})
        .finally(() => {
          window.location.href = `${
            store.getters['company/loginAddress']
          }?returnUrl=${encodeURIComponent(window.location.href)}&massageType=1`
        })
    }
  }
}

/**
 * 检测企业用户手机号、权限与数据库哈希值是否一致，若不一致，弹出提示并返回登录页
 */
export async function verifyUserRuleHandel() {
  // 是否开启国密
  const isGuoMi = store.state.system.isGuoMi
  if (isGuoMi) {
    await store.dispatch('user/getEmployeeInfo')
    await store.dispatch('company/getUserCompanyInfo')
    const role = store.state.user.verifyRoles
    const userId = store.state.user.userId
    const companyId = store.state.company.companyId
    const isAdmin = store.state.user.verifyIsAdmin
    if (userId && companyId) {
      const roleStr = `${userId}_${companyId}_${isAdmin}_${role}`
      const params = {
        empId: store.state.user.employeeId,
        role: roleStr
      }
      const res = await getVerifyUserAuthApi(params)
      if (res?.data && res?.data?.success === false) {
        window.onbeforeunload = null
        store
          .dispatch('user/logout')
          .then(res => {})
          .catch(err => {})
          .finally(() => {
            window.location.href = `${
              store.getters['company/loginAddress']
            }?returnUrl=${encodeURIComponent(
              window.location.href
            )}&massageType=2`
          })
      }
    }
  }
}
